const DAY = 86_400_000;

/** A history day ("YYYY-MM-DD") as a UTC timestamp, for a numeric time axis. */
export const dayTs = (date: string): number => Date.parse(`${date.slice(0, 10)}T00:00:00Z`);

/** "17.10." - day and month; the windows are short enough that the year is noise. */
export const dayLabel = (ts: number): string => {
  const d = new Date(ts);
  return `${String(d.getUTCDate()).padStart(2, '0')}.${String(d.getUTCMonth() + 1).padStart(2, '0')}.`;
};

/**
 * The time axis of a history chart: the span the data covers, but at least
 * `minDays` long and ending on the latest day. A young history (one to a few
 * snapshots) then reads as "this week" instead of being stretched edge to edge,
 * and the axis grows with the data up to the selected range.
 */
export function timeAxis(timestamps: number[], minDays = 7, maxTicks = 7): { domain: [number, number]; ticks: number[] } {
  if (timestamps.length === 0) return { domain: [0, 0], ticks: [] };
  const last = Math.max(...timestamps);
  const first = Math.min(Math.min(...timestamps), last - (minDays - 1) * DAY);
  const spanDays = Math.round((last - first) / DAY);
  const step = Math.max(1, Math.ceil(spanDays / (maxTicks - 1)));
  const ticks: number[] = [];
  for (let ts = last; ts >= first; ts -= step * DAY) ticks.unshift(ts);
  return { domain: [first, last], ticks };
}
